import request from '@/api/request'

export const uploadImage = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/api/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000
  })
}

export const uploadVideo = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/api/upload/video', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000
  })
}
